module.exports = __webpack_public_path__ + "8c4e974a78ef8eca58bcc2f9e2fd98a6.jpg";